import { Redirect, Route, Switch } from "wouter";
import { useAuth } from "./auth";
import { AppLayout } from "./components/AppLayout";
import { ChangePasswordDialog } from "./components/ChangePasswordDialog";
import { AccountingPage } from "./pages/AccountingPage";
import { CommercialPage } from "./pages/CommercialPage";
import { DashboardPage } from "./pages/DashboardPage";
import { EquipmentPage } from "./pages/EquipmentPage";
import { InventoryPage } from "./pages/InventoryPage";
import { LoginPage } from "./pages/LoginPage";
import { MasterDataPage } from "./pages/MasterDataPage";
import { ProductDetailPage } from "./pages/ProductDetailPage";
import { ProductionPage } from "./pages/ProductionPage";
import { ReportsPage } from "./pages/ReportsPage";
import { TraceabilityPage } from "./pages/TraceabilityPage";
import { UsersPage } from "./pages/UsersPage";

export function App() {
  const { user } = useAuth();
  if (!user) {
    return <LoginPage />;
  }

  const isAdmin = user.roles.includes("ADMIN");
  const can = (...permissions: string[]) => isAdmin || permissions.some((permission) => user.permissions.includes(permission));
  const denied = <section className="panel access-denied"><h2>Không có quyền truy cập</h2><p>Tài khoản chưa được cấp quyền xem chức năng này.</p></section>;

  return (
    <>
      <AppLayout>
        <Switch>
          <Route path="/">{can("Dashboard.View") ? <DashboardPage /> : denied}</Route>
          <Route path="/danh-muc">{can("MasterData.View") ? <MasterDataPage /> : denied}</Route>
          <Route path="/danh-muc/san-pham/:code">
            {(params) => can("MasterData.View") ? <ProductDetailPage code={params.code} /> : denied}
          </Route>
          <Route path="/he-thong/nguoi-dung">{isAdmin ? <UsersPage /> : denied}</Route>
          <Route path="/kinh-doanh">{can("Sales.View", "Purchasing.View") ? <CommercialPage /> : denied}</Route>
          <Route path="/san-xuat">{can("Planning.View", "Production.View") ? <ProductionPage /> : denied}</Route>
          <Route path="/thiet-bi">{can("Equipment.View") ? <EquipmentPage /> : denied}</Route>
          <Route path="/kho">{can("Warehouse.View") ? <InventoryPage /> : denied}</Route>
          <Route path="/ke-toan">{can("Accounting.View") ? <AccountingPage /> : denied}</Route>
          <Route path="/truy-xuat">{can("Traceability.View") ? <TraceabilityPage /> : denied}</Route>
          <Route path="/bao-cao">{can("Reports.View") ? <ReportsPage /> : denied}</Route>
          <Route><Redirect to="/" /></Route>
        </Switch>
      </AppLayout>
      {user.mustChangePassword && <ChangePasswordDialog />}
    </>
  );
}
